import React from 'react';

import { getRecord } from 'models/records';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/record',
	components: () => [import(/* webpackChunkName: 'record' */ './component')],
	render: ([Record]) => <Record />,
	onEnter: async ({ store, history, query }) => {
		console.log('on Enter member');

		const { login } = store.getState();
		const [isExpired, isNotGrMember] = [login.isGrMember.expired, !login.isGrMember.isMember];
		// console.log(isExpired, 'isExpired');
		// console.log(isNotGrMember, 'isNotGrMember');

		// token 過期 or 非會員 皆無法進入會員頁
		if (isExpired || isNotGrMember) {
			history.replace('/');
		}

		await store.dispatch(getRecord(Number(query.id)));
		console.log('on Enter member / end');
	},
};

export default routes;
